import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const TabPanel = (props, classes, Box) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className={clsx('h-100', classes.box__padding)}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
};
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default TabPanel;
